import { IconTypes } from '~/components/Icon/IconTypes';

export const RULES = [
  {
    icon: 'navbar_cart' as IconTypes,
    title: 'loyalty:shop:title',
    description: 'loyalty:shop:description',
  },
  {
    icon: 'coins' as IconTypes,
    title: 'loyalty:collect:title',
    description: 'loyalty:collect:description',
  },
  {
    icon: 'percents' as IconTypes,
    title: 'loyalty:save:title',
    description: 'loyalty:save:description',
  },
];
